// потом заменим на тот адрес который нам нужен
export const redirect = (url: string) => {
  window.open(url, '_self');
};
